<template>
  <!--
    "90+INJ" sticker shown in the take-bet modal for World Cup games. Styled
    like the MUST START pill. The pill itself is the hover trigger; the tooltip
    box reuses InformationalTooltip's exact popper styling.
  -->
  <Popper
    class="popper"
    trigger="hover"
    arrow
    placement="top"
    :show="showPopper"
    :z-index="9999"
  >
    <span
      class="inj-90-pill"
      @mouseenter="showPopper = true"
      @mouseleave="showPopper = false"
    >
      90+INJ
    </span>
    <template #content>
      <span class="inj-tooltip-text">{{ NINETY_PLUS_INJ_TOOLTIP }}</span>
    </template>
  </Popper>
</template>

<script setup>
import { ref } from 'vue';
import Popper from 'vue3-popper';
import { NINETY_PLUS_INJ_TOOLTIP } from '@/core/utils';

const showPopper = ref(false);
</script>

<style scoped lang="scss">
@use '@/scss/theme/variables.scss' as theme;

// Match the MUST START pill exactly (TakeBetModal .must-start-pill).
.inj-90-pill {
  display: inline-block;
  vertical-align: middle;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: help;
  background: rgba(245, 158, 11, 0.15);
  color: #b45309;
}

[theme='night'] .inj-90-pill {
  background: rgba(251, 191, 36, 0.16);
  color: #fcd34d;
}

// Tooltip content: size to the text up to a sensible max and wrap normally.
// Without an explicit width the popper collapses inside narrow game cells,
// which is what made the copy wrap one word per line.
.inj-tooltip-text {
  display: block;
  width: max-content;
  max-width: 220px;
  white-space: normal;
  line-height: 1.4;
  text-align: center;
}

// Tooltip box — same selectors InformationalTooltip uses, so the hover box is
// visually identical (white box, border, shadow, arrow).
:deep(.popper) {
  background: theme.$white_01 !important;
  padding: 8px !important;
  box-shadow: 1px 1px 5px 1px theme.$blue-100 !important;
  color: theme.$black-102 !important;
  width: max-content;
  max-width: 220px;
  font-weight: theme.$font-weight-normal !important;
  font-size: theme.$font-size-xs !important;
  border-radius: 2px !important;
  border: 1px theme.$grey-101 solid !important;
  text-align: center;
}

:deep(.popper #arrow::before) {
  background: theme.$white_01;
}

:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
  background: theme.$white_01;
}
</style>
